"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { FlaskConical, ShieldCheck, FileCheck2, MapPin } from "lucide-react";
interface AssuranceItem {
  id: number;
  title: string;
  description: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
  tag: string;
}
const assurances: AssuranceItem[] = [{
  id: 1,
  title: "Rigorous quality control",
  description: "Every synthesis batch undergoes HPLC and mass spectrometry assaying to confirm chemical identity and target purity.",
  icon: FlaskConical,
  tag: "HPLC / MS"
}, {
  id: 2,
  title: "Independently tested",
  description: "Analytical profiles are verified through qualified third-party testing with full batch certificates of analysis.",
  icon: ShieldCheck,
  tag: "COA VERIFIED"
}, {
  id: 3,
  title: "Research-use compliance",
  description: "Reagents are supplied exclusively for in-vitro laboratory research, calibration assays, and scientific investigation.",
  icon: FileCheck2,
  tag: "RUO PROTOCOL"
}, {
  id: 4,
  title: "India-based support",
  description: "Direct technical consultation for academic and institutional laboratories with temperature-controlled domestic dispatch.",
  icon: MapPin,
  tag: "DOMESTIC DISPATCH"
}];
export default function Trust() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.07
      }
    }
  };
  const itemVariants = {
    hidden: shouldReduceMotion ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 10
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.35,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <section id="trust-quality-band" data-nav="light" className="border-y border-border bg-background py-8 md:py-10">
      <div className="mx-auto max-w-[1088px] px-6 md:px-8">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {assurances.map((item, i) => {
          const IconComponent = item.icon;
          return <motion.article key={item.id} data-index={i} variants={itemVariants} className="group relative flex flex-col justify-between border-l-2 border-primary/20 bg-card p-4 transition-[border-color] duration-150 hover:border-primary md:p-5">
                <div>
                  <div className="mb-4 flex items-center justify-between gap-2">
                    <div className="flex h-10 w-10 items-center justify-center rounded-sm bg-muted text-primary">
                      <IconComponent className="h-5 w-5" />
                    </div>
                    <span className="font-mono text-[11px] font-semibold tracking-wider text-muted-foreground">
                      {item.tag}
                    </span>
                  </div>

                  <h4 className="font-default text-base font-semibold text-foreground">
                    {item.title}
                  </h4>

                  <p className="mt-2 text-sm leading-relaxed text-foreground/80">
                    {item.description}
                  </p>
                </div>
              </motion.article>;
        })}
        </motion.div>
      </div>
    </section>;
}